var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetPwdBtn2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 56,
    viewBox: "0 0 300 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_618_12901)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 56,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 50,
    width: 6,
    height: 6,
    transform: "rotate(-90 0 50)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 56,
    width: 6,
    height: 6,
    transform: "rotate(-90 6 56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 0 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 56,
    width: 6,
    height: 6,
    transform: "rotate(-90 282 56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 50,
    width: 6,
    height: 6,
    transform: "rotate(-90 288 50)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 294 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-90 288 12)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 56,
    width: 6,
    height: 6,
    transform: "rotate(-90 294 56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9034 36.216C66.8234 36.216 64.8794 34.128 64.7834 30.96H66.9194C67.0394 33 68.2634 34.272 70.9034 34.272C73.3514 34.272 74.7674 33.312 74.7674 31.392C74.7674 29.76 73.8314 29.04 72.0074 28.656L69.5594 28.128C66.8954 27.552 65.3594 26.16 65.3594 23.592C65.3594 20.88 67.4474 18.984 70.9274 18.984C74.2874 18.984 76.6394 21 76.6634 23.976H74.5274C74.4314 22.152 73.2314 20.952 70.8794 20.952C68.8874 20.952 67.5194 21.816 67.5194 23.592C67.5194 24.96 68.3594 25.68 70.1354 26.088L72.4154 26.616C75.2954 27.288 76.9514 28.632 76.9514 31.392C76.9514 34.392 74.5514 36.216 70.9034 36.216ZM83.1027 36.216C80.0307 36.216 78.0387 34.344 78.0387 31.08V28.656C78.0387 25.392 80.0307 23.52 83.1027 23.52C85.9827 23.52 88.0707 25.152 88.1187 28.656V30.6H80.0787V31.08C80.0787 33.576 81.3267 34.296 83.1027 34.296C84.5907 34.296 85.8387 33.768 86.0547 32.136H88.0947C87.8787 34.728 85.8147 36.216 83.1027 36.216ZM80.0787 28.8H86.0787V28.656C86.0307 26.208 84.7107 25.392 83.1027 25.392C81.3267 25.392 80.0787 26.208 80.0787 28.656V28.8ZM93.8915 36C91.4675 36 90.6275 34.632 90.6275 32.952V25.656H88.8275V23.736H90.6755V21H92.6675V23.736H95.6675V25.656H92.6675V34.08H95.7155V36H93.8915ZM102.101 36V23.736H104.141V24.984C104.789 24.072 105.965 23.52 107.597 23.52C110.309 23.52 112.109 25.344 112.109 28.152V36H110.069V28.608C110.069 26.544 109.085 25.44 107.141 25.44C105.509 25.44 104.141 26.328 104.141 28.608V36H102.101ZM118.851 36.216C115.779 36.216 113.787 34.344 113.787 31.08V28.656C113.787 25.392 115.779 23.52 118.851 23.52C121.731 23.52 123.819 25.152 123.867 28.656V30.6H115.827V31.08C115.827 33.576 117.075 34.296 118.851 34.296C120.339 34.296 121.587 33.768 121.803 32.136H123.843C123.627 34.728 121.563 36.216 118.851 36.216ZM115.827 28.8H121.827V28.656C121.779 26.208 120.459 25.392 118.851 25.392C117.075 25.392 115.827 26.208 115.827 28.656V28.8ZM135.327 36L133.023 24.336L130.719 36H127.023L124.575 23.736H126.711L128.895 35.4L131.151 23.736H134.895L137.151 35.4L139.335 23.736H141.471L139.023 36H135.327ZM147.979 36V19.2H154.147C157.267 19.2 159.235 20.856 159.235 23.712C159.235 26.88 156.859 28.344 153.907 28.344H150.091V36H147.979ZM150.091 26.376H154.027C155.827 26.376 157.051 25.752 157.051 23.736C157.051 21.768 155.827 21.12 154.027 21.12H150.091V26.376ZM164.277 36.216C161.205 36.216 159.237 34.344 159.237 31.08V28.656C159.237 25.392 161.205 23.52 164.277 23.52C165.501 23.52 166.533 23.88 167.301 24.552V23.736H169.341V36H167.301V35.184C166.533 35.856 165.501 36.216 164.277 36.216ZM161.277 31.08C161.277 33.576 162.501 34.296 164.277 34.296C165.933 34.296 167.301 33.576 167.301 31.08V28.656C167.301 26.4 165.933 25.44 164.277 25.44C162.501 25.44 161.277 26.4 161.277 28.656V31.08ZM176.032 36.216C173.128 36.216 171.088 34.8 171.016 31.944H173.032C173.032 33.576 174.28 34.296 176.032 34.296C177.808 34.296 178.84 33.552 178.84 32.52C178.84 31.776 178.312 31.248 177.208 30.96L174.328 30.24C172.576 29.808 171.52 28.728 171.52 26.976C171.52 25.032 173.104 23.52 175.912 23.52C178.696 23.52 180.592 25.152 180.592 27.48H178.624C178.552 26.04 177.448 25.368 175.912 25.368C174.28 25.368 173.464 26.088 173.464 26.976C173.464 27.888 174.16 28.2 175.024 28.416L177.64 29.064C179.728 29.592 180.88 30.648 180.88 32.52C180.88 34.632 179.08 36.216 176.032 36.216ZM186.85 36.216C183.946 36.216 181.906 34.8 181.834 31.944H183.85C183.85 33.576 185.098 34.296 186.85 34.296C188.626 34.296 189.658 33.552 189.658 32.52C189.658 31.776 189.13 31.248 188.026 30.96L185.146 30.24C183.394 29.808 182.338 28.728 182.338 26.976C182.338 25.032 183.922 23.52 186.73 23.52C189.514 23.52 191.41 25.152 191.41 27.48H189.442C189.37 26.04 188.266 25.368 186.73 25.368C185.098 25.368 184.282 26.088 184.282 26.976C184.282 27.888 184.978 28.2 185.842 28.416L188.458 29.064C190.546 29.592 191.698 30.648 191.698 32.52C191.698 34.632 189.898 36.216 186.85 36.216ZM203.164 36L200.86 24.336L198.556 36H194.86L192.412 23.736H194.548L196.732 35.4L198.988 23.736H202.732L204.988 35.4L207.172 23.736H209.308L206.86 36H203.164ZM210.032 28.656C210.032 25.392 212.024 23.52 215.096 23.52C218.168 23.52 220.136 25.392 220.136 28.656V31.08C220.136 34.344 218.168 36.216 215.096 36.216C212.024 36.216 210.032 34.344 210.032 31.08V28.656ZM212.072 31.08C212.072 33.576 213.32 34.296 215.096 34.296C216.872 34.296 218.096 33.576 218.096 31.08V28.656C218.096 26.4 216.872 25.44 215.096 25.44C213.32 25.44 212.072 26.4 212.072 28.656V31.08ZM222.068 36V23.736H224.108V25.152C224.708 24.264 225.596 23.736 227.228 23.736H228.452V25.776H227.228C225.38 25.776 224.108 26.808 224.108 29.352V36H222.068ZM233.614 36.216C230.542 36.216 228.574 34.344 228.574 31.08V28.656C228.574 25.392 230.542 23.52 233.614 23.52C234.838 23.52 235.87 23.88 236.638 24.552V18.24H238.678V36H236.638V35.184C235.87 35.856 234.838 36.216 233.614 36.216ZM230.614 31.08C230.614 33.576 231.838 34.296 233.614 34.296C235.27 34.296 236.638 33.576 236.638 31.08V28.656C236.638 26.4 235.27 25.44 233.614 25.44C231.838 25.44 230.614 26.4 230.614 28.656V31.08Z",
    fill: "#F5F5F5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 299.5,
    height: 55.5,
    stroke: "black",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_618_12901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPwdBtn2);
export default __webpack_public_path__ + "static/media/ResetPwdBtn2.6dffd5371fb1264d891c2c7837ebeba4.svg";
export { ForwardRef as ReactComponent };